export const PriceRuleCustomFilters = {
    cartDiscount: 'cartDiscount',
    employeeDiscount: 'employeeDiscount',
    sunsetPoints: 'sunsetPoints',
    freeMeal: 'freeMeal',
    giveawayCampaign: 'giveawayCampaign',
    pointUserRegistration: 'pointUserRegistration',
    includeQualifyingProducts: 'includeQualifyingProducts',
    mysteryBoxRandomActOfKindness: 'mysteryBoxRandomActOfKindness',
    mysteryBoxLower: 'mysteryBoxLower',
    mysteryBoxHigher: 'mysteryBoxHigher',
    sunsetPlusTier: 'sunsetPlusTier',
    milestoneReward: 'milestoneReward',
};
